import { isFsvListing } from "../../../../components/src/app-mylistings/utils/listing-fsv.utils";
import { useGetFsvListingQuery } from "../../../../components/src/services/listings.service";
import { useGetSpaceQuery } from "../../../../components/src/services/spaces.service";

type UseListingFsvDataArgs = {
  listingId: string;
};

/**
 * SpacesAPI has no endpoint keyed by listing id (every space route is keyed
 * by `:spaceId`), so the parent space is fetched in a second step once the
 * listing tells us its `parentSpaceId`.
 */
const useListingFsvData = ({ listingId }: UseListingFsvDataArgs) => {
  const {
    data: listing,
    isError: isListingError,
    isFetching: isListingFetching,
  } = useGetFsvListingQuery({ listingId });

  const parentSpaceId = listing?.parentSpaceId;

  const {
    data: space,
    isError: isSpaceError,
    isFetching: isSpaceFetching,
  } = useGetSpaceQuery(
    { spaceId: parentSpaceId ?? "" },
    { skip: !parentSpaceId },
  );

  return {
    listing,
    space,
    isFetching: isListingFetching || isSpaceFetching,
    isError: (isListingError && !listing) || (isSpaceError && !space),
    isFsv: isFsvListing(listing),
  };
};

export { useListingFsvData };
